import client from "api/client";

// F1 / H1 — authorsApi. Website-scoped /websites/{websiteId}/authors. The
// scoped list returns the website's authors plus globals. `is_global` authors
// are shared across websites; the rest are website-specific.

export const listAuthors = async (websiteId) => {
  const { data } = await client.get(`/websites/${websiteId}/authors`);
  return data.items ?? [];
};

// Paginated variant — returns { items, total, hasMore } for the Authors table.
export const listAuthorsPaged = async (websiteId, { limit = 25, offset = 0, search } = {}) => {
  const params = { limit, offset, sort_by: "created_at", sort_desc: true };
  if (search) params.search = search;
  const { data } = await client.get(`/websites/${websiteId}/authors`, { params });
  return { items: data.items ?? [], total: data.total ?? 0, hasMore: !!data.has_more };
};

export const getAuthor = async (websiteId, id) => {
  const { data } = await client.get(`/websites/${websiteId}/authors/${id}`);
  return data;
};

// createAuthor requires first_name + last_name; optional email, bio,
// profile_image, social_links, is_global.
export const createAuthor = async (websiteId, payload) => {
  const { data } = await client.post(`/websites/${websiteId}/authors`, payload);
  return data;
};

export const updateAuthor = async (websiteId, id, payload) => {
  const { data } = await client.put(`/websites/${websiteId}/authors/${id}`, payload);
  return data;
};

export const deleteAuthor = async (websiteId, id) => {
  await client.delete(`/websites/${websiteId}/authors/${id}`);
};
